export function getLabelItemProps(item) {
  return item
}
